export default "__VITE_ASSET__B2ClWftk__"